import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  { path: "*", redirect: "/pages/404" },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/Login.vue"),
  },
  {
    path: "/selectList",
    name: "selectList",
    component: () => import("@/views/login/SelectList.vue"),
  },
  {
    path: "/pages",
    name: "pages",
    component: () => import("@/views/pages/Pages.vue"),
    children: [
      {
        path: "/desktopView",
        name: "desktopView",
        component: () => import("@/views/pages/PagesChildren/DesktopView.vue"),
      },
      {
        path: "/404",
        name: "pageNotFound",
        component: () => import("@/views/pages/PagesChildren/PageNotFound.vue"),
      },
      {
        path: "/404",
        name: "unauthorized",
        component: () => import("@/views/pages/PagesChildren/Unauthorized.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
